import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MediaDevicesService {
	constructor() {}

	getUserMedia(options: MediaStreamConstraints): Observable<MediaStream> {
		return new Observable(observable => {
			navigator.mediaDevices
				.getUserMedia(options)
				.then(stream => {
					observable.next(stream);
					observable.complete();
				})
				.catch(error => {
					observable.error(error);
					observable.complete();
				});
		});
	}
}
